import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'loyalty-progress-bar',
  props: {
    earned: { default: 0 },
    pending: { default: 0 },
    total: { default: 100 },
    mode: { default: 'details' },
    pointsToNextReward: { default: 0 },
    spendToNextReward: { default: '' }
  },
  setup(__props: any) {

const props = __props as { earned: number, pending: number, total: number, mode: string, pointsToNextReward: number, spendToNextReward: string };



const displayedEarned = ref(0);

function animateNumber(from: number, to: number) {
  const duration = 500;
  const start = performance.now();

  function tick(now: number) {
    const progress = Math.min((now - start) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    displayedEarned.value = Math.round(from + (to - from) * eased);
    if (progress < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}

const earnedPct = computed(() => Math.min(props.earned / props.total * 100, 100));
const pendingPct = computed(() => Math.min((props.earned + props.pending) / props.total * 100, 100));

onMounted(() => animateNumber(0, props.earned));

watch(() => props.earned, (newVal) => {
  animateNumber(displayedEarned.value, newVal);
});

return { __sfc: true,props, displayedEarned, animateNumber, earnedPct, pendingPct }
}

})